var _g, _g2, _g3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 144,
    viewBox: "0 0 134 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 309",
    fill: "#fff",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13h124a5 5 0 015 5v111a15 15 0 01-15 15H15a15 15 0 01-15-15V18a5 5 0 015-5z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5h124a4.5 4.5 0 014.5 4.5v111a14.5 14.5 0 01-14.5 14.5H15A14.5 14.5 0 01.5 129V18A4.5 4.5 0 015 13.5z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 311",
    transform: "translate(34)",
    fill: "#fff",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 26,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 25,
    rx: 4,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 312",
    transform: "translate(92)",
    fill: "#fff",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 26,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 25,
    rx: 4,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 87",
    fill: "none",
    stroke: "#707070",
    d: "M133.5 46.5H.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon--calendar.3235960e35e3f76f9de47ba77c85ac6c.svg";
export { ForwardRef as ReactComponent };